import { draftsTabUIInitialState } from "./uiLandingPageDraftsTabState";

export const makeDraftsTabUIActions = (set, get) => ({
  setShowDelForm: (show) =>
    set((s) => ({ draftsTabUI: { ...s.draftsTabUI, showDelForm: !!show } })),
  setShowTransferDelModal: (show) =>
    set((s) => ({
      draftsTabUI: { ...s.draftsTabUI, showTransferDelModal: !!show },
    })),
  resetDraftsTabUI: () => set({ draftsTabUI: draftsTabUIInitialState }),
});
